/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PipelineRun
 */
export interface PipelineRun {
    /**
     * 
     * @type {string}
     * @memberof PipelineRun
     */
    runId: string;
}

/**
 * Check if a given object implements the PipelineRun interface.
 */
export function instanceOfPipelineRun(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;

    return isInstance;
}

export function PipelineRunFromJSON(json: any): PipelineRun {
    return PipelineRunFromJSONTyped(json, false);
}

export function PipelineRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): PipelineRun {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
    };
}

export function PipelineRunToJSON(value?: PipelineRun | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'run_id': value.runId,
    };
}

